import { createSmartDocPillBuilder } from 'owa-mail-smart-doc';
import { createSmartReplyPillBuilder } from 'owa-mail-smart-reply';
import { createSmartTimePillBuilder } from 'owa-mail-smart-time';
import { createSmartTodoPillBuilder, createSmartReminderPillBuilder } from 'owa-mail-smart-task';
import { ClientItem } from 'owa-mail-store';
import { SmartPillBuilder } from 'owa-smart-pill';
import { isFeatureEnabled } from 'owa-feature-flags';

export default function registerSmartPillBuilders(item: ClientItem): SmartPillBuilder[] {
    const smartPillBuilders: SmartPillBuilder[] = [];

    // Arbitrator handles flight checking
    smartPillBuilders.push(createSmartTimePillBuilder(item));
    smartPillBuilders.push(createSmartDocPillBuilder(item));
    smartPillBuilders.push(createSmartReplyPillBuilder(item));
    smartPillBuilders.push(createSmartTodoPillBuilder(item));

    if (isFeatureEnabled('mc-smartTaskWithReminder')) {
        smartPillBuilders.push(createSmartReminderPillBuilder(item));
    }

    return smartPillBuilders;
}
